import { z } from 'zod';

export const UuidSchema = z.string().uuid();
export const IsoTimestampSchema = z.string().datetime({ offset: true });

export const APPLICATION_STATUSES = ['active', 'paused', 'revoked'] as const;
export const ApplicationStatusSchema = z.enum(APPLICATION_STATUSES);

export const APPLICATION_ENVIRONMENTS = ['development', 'production'] as const;
export const ApplicationEnvironmentSchema = z.enum(APPLICATION_ENVIRONMENTS);

export const ALERT_SEVERITIES = ['low', 'medium', 'high', 'critical'] as const;
export const AlertSeveritySchema = z.enum(ALERT_SEVERITIES);

export const ALERT_RULE_STATUSES = ['active', 'paused'] as const;
export const AlertRuleStatusSchema = z.enum(ALERT_RULE_STATUSES);

export const HexColorSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'must be a 6-digit hex color');

export type ApplicationStatus = z.infer<typeof ApplicationStatusSchema>;
export type ApplicationEnvironment = z.infer<typeof ApplicationEnvironmentSchema>;
export type AlertSeverity = z.infer<typeof AlertSeveritySchema>;
export type AlertRuleStatus = z.infer<typeof AlertRuleStatusSchema>;
